import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import axios from 'axios'
import VueAxios from 'vue-axios'
import iView from 'iview'
import VueDND from 'awe-dnd'

import 'iview/dist/styles/iview.css'
import '@/assets/main.css'

Vue.config.productionTip = false

Vue.use(iView)
Vue.use(VueAxios, axios)
Vue.use(VueDND)

if (Vue.config.devtools) {
  axios.defaults.baseURL = 'http://localhost/expedc/api/web/v1/'
} else {
  axios.defaults.baseURL = 'https://expedc.comtrial.com/v1/'
}
axios.defaults.headers.get['Content-Type'] = 'application/json'
axios.defaults.headers.get['Accept'] = 'application/json'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token')
axios.defaults.headers.common['Study-Id'] = sessionStorage.getItem('studyid')

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
